import {ServiceBase} from "../ServiceBase";
import {IGetGnwpGameUrlRequest, IGnwpService} from "./gnwp.service.interface";
import {IGNWPRequestModel} from "../../../sdk/src/services/gnwp/gnwp_service_interface";
import {Check} from "@sparkware/app-utils";

export class GnwpService extends ServiceBase implements IGnwpService {
    async getGameUrl(request: IGetGnwpGameUrlRequest): Promise<string> {
        const gnwpRequest: IGNWPRequestModel = {
            templateName: request.templateName,
            gameType: request.gameType,
            isReal: request.isReal,
            currencyCode: this.services.currency.currencyIso3,
            externalGameCode: request.externalGameCode,
            isHistory: request.isHistory || false,
            gameId: request.historyGameRoundId,
            historyRoundStartDate: request.historyRoundStartDate,
            token: request.token
        };

        if(!Check.isUndefined(request.gameLimit)) {
            gnwpRequest.gameLimit = request.gameLimit;
        }

        if(!Check.isUndefined(request.requestedGameLimit)) {
            gnwpRequest.requestedTimeLimit = request.requestedGameLimit;
        }

        if(!Check.isUndefined(request.requestedTimeLimit)) {
            gnwpRequest.requestedTimeLimit = request.requestedTimeLimit;
        }
        if(!Check.isUndefined(request.restrictionPeriod)) {
            gnwpRequest.restrictionPeriod = request.restrictionPeriod;
        }
        if(!Check.isUndefined(request.intervalReminder)) {
            gnwpRequest.intervalReminder = request.intervalReminder;
        } else {
            gnwpRequest.intervalReminder = 0;
        }

        if(!Check.isUndefined(request.historyGameRoundId)) {
            gnwpRequest.gameId = request.historyGameRoundId;
        }

        if(!Check.isUndefined(request.target)) {
            gnwpRequest.target = request.target;
        }

        if(!Check.isUndefined(request.isOSS)) {
            gnwpRequest.isOSS = request.isOSS;
        }

        //We use it only for AOD NYX
        if(!Check.isUndefined(request.NyxLinkID)) {
            gnwpRequest.NyxLinkID = request.NyxLinkID;
        }

        if(!Check.isUndefined(request.NetEntGameHistoryLinkID)) {
            gnwpRequest.NetEntGameHistoryLinkID = request.NetEntGameHistoryLinkID;
        }

        if(!Check.isNullOrUndefined(request.hasInGameHistory)) {
            gnwpRequest.hasInGameHistory = request.hasInGameHistory;
        }

        const gnwpResponse = await this.services.sdk.gnwp.getGNWPResponse(gnwpRequest);

        return gnwpResponse.getGNWPUrl();
    }

}